<template>
  <v-dialog v-model="dialogConfirm" persistent width="400">
    <v-card>
      <v-card-text style="height: 100px">
        <h2 class="text-xs-center mt-4">Tem certeza que quer excluir?</h2>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" dark @click="$emit('removeData')"> Sim </v-btn>
        <v-btn color="green" dark @click="dialogConfirm = false"> Não </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({}),
  props: ["dialogConfirm"],
  watch: {
    dialogConfirm(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="scss" scoped></style>
